'use strict';
window.jQuery = window.$ = require('jquery');
var slick 			= require('slick-carousel');

$( document ).ready(function() {


	$('#quick-assess-main__slider').slick({
		arrows: false,
		dots: false,
		swipe: false,
		adaptiveHeight: true
	});

	$('.slider-content-slider').slick({
		swipe: false,
		dots: false,
		arrows: true,
		adaptiveHeight: true,
		nextArrow: '<a class="slick-next slick-arrow"><img src="images/arrow_right.png" /></a>',
		prevArrow: '<a class="slick-prev slick-arrow"><img src="images/arrow_left.png" /></a>',
	});

	$('#quick-assess-main__nav li').on('click',function(){
		$('#quick-assess-main__nav li.active').removeClass('active');
		$(this).addClass('active');
		$('#quick-assess-main__slider').slick('slickGoTo', $(this).index());
	});

	$('.question-expander .show-less').on('click',function(e){
		e.preventDefault();
		$(this).closest('.question-expander').removeClass('expanded');
	});
	$('.question-expander .show-more').on('click',function(e){
		e.preventDefault();
		$(this).closest('.question-expander').addClass('expanded');
	});


	if($('#assessment-questions').length > 0){
		var resetQuestionSliderHeight = function(){
			var h = $(window).height() - $('#topbar').outerHeight(true) - $('#assessment-questions__header').outerHeight(true) - $('#assessment-footer').outerHeight(true);
			$('#assessment-questions').height(h);
		}
		resetQuestionSliderHeight();
		$(window).on('resize',resetQuestionSliderHeight);

		var checkDirectionals = function(){
			
			if($('.assessment-question').first().hasClass('active')) {
				$('#question-directional-up').attr('disabled',true);
			} else {
				$('#question-directional-up').removeAttr('disabled');
			}

			if(!$('.assessment-question.active').hasClass('has-answer') || $('.assessment-question.active').hasClass('final-question')) {
				$('#question-directional-down').attr('disabled',true);
			} else {
				$('#question-directional-down').removeAttr('disabled');
			}

			var i = $('.assessment-question.active').index();
			if(i > 8) {
				$('#assessment-questions__header h1').text('Part 4: Business Integration - Performance Measures');
				$('#assessment-questions__header h3').html('To what extent are the following <em>performance measures</em> for your product sustainability program used in your organization?');
			} else if(i > 5) {
				$('#assessment-questions__header h1').text('Part 3: Business Integration - Key Functions');
				$('#assessment-questions__header h3').html('To what extent do the following <em>key functions</em> have sustainability included in their every-day business processes?');
			} else if(i > 2) {
				$('#assessment-questions__header h1').text('Part 2: Corporate Alignment - Structured Goals');
				$('#assessment-questions__header h3').html('To what extent are you leveraging the following elements of <em>structured goals</em>?');
			} else {
				$('#assessment-questions__header h1').text('Part 1: Corporate Alignment - Leadership Engagement');
				$('#assessment-questions__header h3').html('To what extent is the <em>leadership engaged</em> in product sustainability?');
			}
			resetQuestionSliderHeight();

			$('#assessment-questions').clearQueue().animate({scrollTop: $('#assessment-questions').scrollTop() + $('.assessment-question.active').position().top }, 500);

			setInterval(resetQuestionSliderHeight, 200);
		};

		var goToNextQuestion = function(){
			var q = $('.assessment-question.active'), next_q = q.next('.assessment-question');
			if(!q.hasClass('has-answer')) {
				next_q = q;
			} else if(next_q.length > 0){
				q.removeClass('active');
				next_q.addClass('active');
			}
			next_q.scrollTop(0);
			// $('#assessment-questions').clearQueue().animate({scrollTop: $('#assessment-questions').scrollTop() + next_q.position().top }, 500);
			checkDirectionals();
		}

		var goToPrevQuestion = function(){
			var q = $('.assessment-question.active'), prev_q = q.prev('.assessment-question');
			if(prev_q.length > 0){
				q.removeClass('active');
				prev_q.addClass('active').scrollTop(0);
				// $('#assessment-questions').clearQueue().animate({scrollTop: $('#assessment-questions').scrollTop() + prev_q.position().top }, 500);
			}
			checkDirectionals();
		}

		$('#assessment-questions input[type="radio"]').on('click',function(e){
			var q = $(this).closest('.assessment-question');
			if(q.hasClass('active')) {
				q.addClass('has-answer');
				
				goToNextQuestion();
				$('#assessment-questions__header').addClass('smaller');
				
			} else {
				return false;
			}
		});

		$('input[type="text"], input[type="email"]').on('focus click',function(e){
			var q = $(this).closest('.assessment-question');
			if(!q.hasClass('active')) {
				$(this).blur();
				e.preventDefault();
				return false;
			}
		});

		$('input[type="text"], input[type="email"]').on('keydown',function(e){
			if(e.keyCode == 13) {
				e.preventDefault();
				return false;
			}
		});

		var formVerify = function(){
	        var emailValidate = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	        if($('#assessment-field-email').val() != '' && !emailValidate.test($('#assessment-field-email').val())){
	        	return { error: true, message: 'Email address is invalid' };
	        } else if($('#assessment-field-email').val() != '' &&
				$('#assessment-field-first_name').val() != '' &&
				$('#assessment-field-last_name').val() != '' &&
				$('#assessment-field-company').val() != '') {
				return { error: false };
			}
    		return { error: true, message: 'Please fill out all fields' };
		}

		$('.assessment-wrapper').on('submit',function(e){
			var verify = formVerify();
			if(verify.error){
				alert(verify.message);
				e.preventDefault();
				return false;
			}
		});

		$('#question-directional-up').on('click',goToPrevQuestion);
		$('#question-directional-down').on('click',goToNextQuestion);

		$('#assessment-questions input[type="radio"]').on('change',function(){
			$('#assessment-progress li').eq($(this).closest('.assessment-question').index()).addClass('active');
			$('span.progress-count').text($('#assessment-questions .assessment-question.has-answer:not(.final-question)').length);

			if($('#assessment-progress li').not('.active').length < 1) {
				$('.assessment-question').addClass('has-answer');
			}
		});
	}

	// if($('.assessment-wrapper__right').length > 0) {
	// 	function sizeResultsRightColumn(){
	// 		var that = $('.assessment-wrapper__right');
	// 		that.css('height','auto');
	// 		var h = that.parent().height() + ($('#assessment-footer').length > 0 ? $('#assessment-footer').outerHeight(true) : 0);
	// 		that.css('height',h);
	// 	}
	// 	sizeResultsRightColumn();
	// 	$(window).on('resize',sizeResultsRightColumn);
	// }

	$('.print-window').on('click',function(e){
		e.preventDefault();
		window.print();
	});

	var setSticky = function() {
		var h = $(window).height() - $('#topbar').outerHeight(true);
		if($('#assessment-footer').length > 0) {
			h -= $('#assessment-footer').outerHeight(true);
		} 

		$('.assessment-wrapper__right .sticky')
			.css('width', $('.assessment-wrapper__right').width())
			.css('maxHeight', h)
			.css('top', $('.assessment-wrapper__right').offset().top);
	}
	if($('.assessment-wrapper__right .sticky').length > 0) {
		setSticky();
		$(window).on('resize',setSticky);
	}

	$('.study__header').on('click',function(e){
		e.preventDefault();
		var s = $(this).closest('.study');
		s.toggleClass('active');
		s.find('.study__content').slideToggle();
	});

	$('.open-subscribe-modal').on('click',function(e){
		e.preventDefault();
		$('#subscribe-modal__bg, #subscribe-modal__content').fadeIn();
	});
	$('#close-subscribe-modal, #subscribe-modal__bg').on('click',function(e){
		e.preventDefault();
		$('#subscribe-modal__bg, #subscribe-modal__content').fadeOut();
	});

});